import styled from 'styled-components'
import { widthResize, widthFull } from '../Resources/Theme'

const PageWrapper = styled.div`
  margin-left: ${props => props.resize ? widthResize : widthFull};
  width: calc(100% - ${props => props.resize ? widthResize : widthFull});
  transition: .5s;

  @media (max-width: 992px) {
    width: 100%;
    margin-left: 0;
  }
`
PageWrapper.BgTop = styled.div`
  top: 0;
  padding: 34px 28px 0;
  width: 100%;
  min-height: 200px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: #2c2a20;
  border-bottom-left-radius: 32px;

  @media(max-width: 480px) {
    min-height: 160px;
    padding: 24px 18px 0;
  }
`
PageWrapper.Title = styled.h4`
  margin-bottom: 0;
  align-self: flex-start;
  font-size: clamp(1.8rem, 2.6vw, 2.4rem);
  line-height: 1.1;
  color: #fff;
  font-weight: 700;

  @media (max-width: 992px) {
    font-size: 1.3rem;
  }
`
PageWrapper.Body = styled.div`
  position: relative;
  top: -64px;
  padding: 0 28px 32px;
  min-height: calc(100vh - 240px);

  @media (max-width: 768px) {
    top: -42px;
    padding: 0 18px 24px;
  }
`

/* Start BreadCrumb */
PageWrapper.BreadCrumb = styled.div`
  font-weight: 500;
  display: flex;
  align-self: flex-start;
  margin-top: 0.6rem;
  color: rgba(255, 255, 255, 0.82);
  
  @media (max-width: 992px) {
    display: none;
  }
`
PageWrapper.BreadCrumb.Title = styled.span`
  margin-right: .7rem;
  display: flex;
  font-weight: ${props => props.active ? '700' : '500'};
  align-self: center;
`
PageWrapper.BreadCrumb.Icon = styled.div`
  align-self: center;
  transform: rotate(135deg);
  content: '';
  width: 5px;
  height: 5px;
  border-width: 2px 0 0 2px;
  border-style: solid;
  margin-right: .7rem;
`
/* End BreadCrumb */

export default PageWrapper